import { takeEvery } from 'redux-saga/effects';
import { SagaIterator } from '@redux-saga/types';
import { fetchAddPost, fetchEditPost } from '../actions';
import { workerAddPost, workerEditPost } from './workers';

export default function* watchAddPost(): SagaIterator {
  yield takeEvery<typeof fetchAddPost>(fetchAddPost, workerAddPost);
  yield takeEvery<typeof fetchEditPost>(fetchEditPost, workerEditPost);
}
